import { InjectionToken } from '@angular/core';

import { ISnAbilityConfig } from '../interfaces';

export const SN_ABILITY_CONFIG = new InjectionToken<ISnAbilityConfig>('SN_ABILITY_CONFIG');

export function snAbilityConfigFactory(config: Partial<ISnAbilityConfig>): ISnAbilityConfig {
  return {
    redirectForbiddenTo: '/',
    ...config,
  };
}
